import { SpectrumColor } from '../types';

export const Gray: SpectrumColor = {
  0: '#FBFAF9',
  5: '#F6F3F0',
  10: '#E9E5E2',
  15: '#E4DFDB',
  20: '#DED9D4',
  25: '#D8D2CD',
  30: '#D2CBC5',
  35: '#C6BFB9',
  40: '#B9B2AC',
  50: '#A19991',
  60: '#878078',
  70: '#6A6662',
  80: '#4D4E56',
  90: '#34353D',
  100: '#1E1F24',
  110: '#0D0E11',
  default: 90,
};
